import { useTranslation } from 'react-i18next';
import { useHistory, generatePath } from 'react-router-dom';

import { routes } from 'client-config';
import type { CostOffsetCode } from 'domains-billing-types';
import { useChannelAdminContext } from 'hooks';

export interface CostOffsetCodeAction {
  label: string;
  onSelect: (row: CostOffsetCode) => void;
}

export function useGetActionsForCostOffsetCodes(): CostOffsetCodeAction[] {
  const { t } = useTranslation();
  const history = useHistory();
  const { channel } = useChannelAdminContext();
  const channelSlug = channel?.slug || '';

  return [
    {
      label: t('abp.productsServices.costOffsetCodes.actions.edit'),
      onSelect: (row: CostOffsetCode) => {
        history.push(
          generatePath(routes.channelAdminEditCostOffsetCodeForm, {
            id: channelSlug,
            costOffsetCodeId: row.id,
          })
        );
      },
    },
  ];
}
